import { createSlice } from "@reduxjs/toolkit";
import {
  getPermission,
  AddPermission,
  DeletePermission,
  AddUser,
  getAccountUser,
  DeleteUser,
  CreatePassword,
  GetUserandPermission,
  SendToEmail,
  PostVerify,
  EditAccountUser,
  GetUser,
  editPermission,
  editUser,
} from "API/PermissionAPI";

const initialState = {
  Permission: [],
  AddPermission: [],
  DeletePermissions: [],
  EditPermissions: [],
  User: [],
  UserDetails: [],
  AddUser: [],
  EditUser: [],
  DeleteUser: [],
  UserAndPermission: [],
  Email: [],
  Verify: [],
  Edit: [],
  Password: [],
  loading: false,
};

export const UserSlice = createSlice({
  name: "UserState",
  initialState,
  reducers: {
    updateGetPermission: (state, action) => {
      state.Permission = action.payload;
    },
    updateAddPermission: (state, action) => {
      state.AddPermission = action.payload;
    },
    updateDeletePermission: (state, action) => {
      state.DeletePermissions = action.payload;
    },
    updateAddUser: (state, action) => {
      state.AddUser = action.payload;
    },
    updateGetAccountUser: (state, action) => {
      state.User = action.payload;
    },
    updateDeleteUser: (state, action) => {
      state.DeleteUser = action.payload;
    },
    updateCreatePassword: (state, action) => {
      state.Password = action.payload;
    },
    updateGetUserandPermission: (state, action) => {
      state.UserAndPermission = action.payload;
    },
    updateSendToEmail: (state, action) => {
      state.Email = action.payload;
    },
    updatePostVerify: (state, action) => {
      state.Verify = action.payload;
    },
    updateEditAccountUser: (state, action) => {
      state.User = action.payload;
    },
    updateGetUser: (state, action) => {
      state.UserDetails = action.payload;
    },
    updateEditPermission: (state, action) => {
      state.EditPermissions = action.payload;
    },
    updateEditUser: (state, action) => {
      state.EditUser = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setLoading } = UserSlice.actions;
export const { updateGetPermission } = UserSlice.actions;
export const getPermissionDetail = (value) => async (dispatch) => {
  await getPermission(value).then(async (data) => {
    await dispatch(updateGetPermission(data));
  });
};

export const { updateAddPermission } = UserSlice.actions;
export const AddPermissionDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await AddPermission(value);
    dispatch(updateAddPermission(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    dispatch(setLoading(false));
    throw error;
  }
};

export const { updateDeletePermission } = UserSlice.actions;
export const DeletePermissionDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await DeletePermission(value);
    dispatch(updateDeletePermission(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    dispatch(setLoading(false));
    throw error;
  }
};

export const { updateAddUser } = UserSlice.actions;
export const AddUserDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await AddUser(value);
    dispatch(updateAddUser(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    dispatch(setLoading(false));
    throw error;
  }
};

export const { updateGetAccountUser } = UserSlice.actions;
export const getAccountUserDetail = (value) => async (dispatch) => {
  await getAccountUser(value).then(async (data) => {
    await dispatch(updateGetAccountUser(data));
  });
};

export const { updateDeleteUser } = UserSlice.actions;
export const DeleteUserDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await DeleteUser(value);
    dispatch(updateDeleteUser(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    dispatch(setLoading(false));
    throw error;
  }
};

export const { updateCreatePassword } = UserSlice.actions;
export const CreatePasswordDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await CreatePassword(value);

    dispatch(updateCreatePassword(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    dispatch(setLoading(false));
    throw error;
  }
};

export const { updateGetUserandPermission } = UserSlice.actions;
export const GetUserandPermissionDetail = (value) => async (dispatch) => {
  await GetUserandPermission(value).then(async (data) => {
    await dispatch(updateGetUserandPermission(data));
  });
};

export const { updateSendToEmail } = UserSlice.actions;
export const SendToEmailDetail = (value) => async (dispatch) => {
  await SendToEmail(value).then(async (data) => {
    await dispatch(updateSendToEmail(data));
  });
};

export const { updateEditAccountUser } = UserSlice.actions;
export const EditAccountUserDetail = (value) => async (dispatch) => {
  await EditAccountUser(value).then(async (data) => {
    await dispatch(updateEditAccountUser(data));
  });
};

export const { updateGetUser } = UserSlice.actions;
export const GetUserDetail = (value) => async (dispatch) => {
  await GetUser(value).then(async (data) => {
    await dispatch(updateGetUser(data));
  });
};

export const { updatePostVerify } = UserSlice.actions;
export const PostVerifyDetail = (value) => async (dispatch) => {
  console.log(value);
  
  try {
    const data = await PostVerify(value);
    const status = data?.status;
    dispatch(updatePostVerify(status));
    return Promise.resolve(status);
  } catch (error) {
    throw error;
  }
};

export const { updateEditPermission } = UserSlice.actions;
export const EditPermissionDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await editPermission(value);
    dispatch(updateEditPermission(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    dispatch(setLoading(false));
    throw error;
  }
};

export const { updateEditUser } = UserSlice.actions;
export const EditUserDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await editUser(value);
    dispatch(updateEditUser(data));
    dispatch(setLoading(false));
    return data;
  } catch (error) {
    dispatch(setLoading(false));
    throw error;
  }
};

export default UserSlice.reducer;
